import type { StyleRule } from '@archipro-design/aria';
import { getScrollbarStyle } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';

export const TeamMemberDialofStyle: StyleRule = ({ theme }) => {
    return {
        [theme.screen.tablet]: {
            marginTop: pxToRem(124),
            marginBottom: pxToRem(124),
        },
    };
};

export const TeamMemberHeaderStyle: StyleRule = {
    display: 'block',
    marginTop: pxToRem(30),
    marginLeft: pxToRem(28),
    marginBottom: pxToRem(-1),
    height: 'auto',
};

export const CloseButton: StyleRule = ({ theme }) => ({
    fontSize: pxToRem(20),
    color: theme.siteVariables.colors.charcoal['000'],
    letterSpacing: '0.01em',
    cursor: 'pointer',
    fontWeight: theme.siteVariables.textStyles.Text.Medium65.fontWeight,
});

export const TeamMemberTop: StyleRule = ({ theme }) => ({
    fontSize: pxToRem(24),
    marginTop: pxToRem(45),
    fontWeight: theme.siteVariables.textStyles.Text.Medium65.fontWeight,
    letterSpacing: '-0.01em',
    color: theme.siteVariables.colors.charcoal['000'],
});

export const TeamMemberWrapper: StyleRule = ({ theme }) => ({
    height: 'auto',
    overflowX: 'hidden',
    overflowY: 'auto',
    paddingTop: pxToRem(7.5),
    paddingLeft: pxToRem(27.5),
    border: 'none !important',
    paddingRight: pxToRem(15),
    margin: '0 !important',
    ...getScrollbarStyle(theme, '0'),
});
